module.exports = __webpack_public_path__ + "static/media/on.18a37a36.png";